import { render } from "./TextPageApp.vue?vue&type=template&id=5768256a"
import script from "./TextPageApp.vue?vue&type=script&lang=js"
export * from "./TextPageApp.vue?vue&type=script&lang=js"

import "./TextPageApp.vue?vue&type=style&index=0&id=5768256a&lang=sass"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__